import { Button } from "reactstrap";

export const handleRenderReportStatus = ({
    status,
    user,
    updateUserStatusHandler,
    t,
}) => {
    if (!user.show_activate_button) return null;

    const statusMapping = {
        ACTIVE: { color: "success", nextStatus: "INACTIVE", label: t("Active") },
        INACTIVE: { color: "danger", nextStatus: "ACTIVE", label: t("Inactive") },
    };

    const { color, nextStatus, label } = statusMapping[status] || {};
    return (
        <Button
            color={color}
            size="sm"
            onClick={() => updateUserStatusHandler(user, nextStatus)}
        >
            {label}
        </Button>
    );
};

